/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetDefaultLanguageRequest
 */
export interface SetDefaultLanguageRequest {
    /**
     * 
     * @type {string}
     * @memberof SetDefaultLanguageRequest
     */
    language: string;
}

/**
 * Check if a given object implements the SetDefaultLanguageRequest interface.
 */
export function instanceOfSetDefaultLanguageRequest(value: object): value is SetDefaultLanguageRequest {
    if (!('language' in value) || value['language'] === undefined) return false;
    return true;
}

export function SetDefaultLanguageRequestFromJSON(json: any): SetDefaultLanguageRequest {
    return SetDefaultLanguageRequestFromJSONTyped(json, false);
}

export function SetDefaultLanguageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultLanguageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'],
    };
}

export function SetDefaultLanguageRequestToJSON(json: any): SetDefaultLanguageRequest {
    return SetDefaultLanguageRequestToJSONTyped(json, false);
}

export function SetDefaultLanguageRequestToJSONTyped(value?: SetDefaultLanguageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'language': value['language'],
    };
}

